import { http } from '../../http';
import { ResponseGetChannels } from './types';

export const getChannels = async () => {
    return http
        .get<ResponseGetChannels>('/channels')
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error fetching channels', error);
            throw error;
        });
};
